var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 513 513",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.746 432.145C185.583 432.145 192.746 424.982 192.746 416.145C192.746 407.308 185.583 400.145 176.746 400.145C167.91 400.145 160.746 407.308 160.746 416.145C160.746 424.982 167.91 432.145 176.746 432.145Z",
    stroke: "black",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M400.746 432.145C409.583 432.145 416.746 424.982 416.746 416.145C416.746 407.308 409.583 400.145 400.746 400.145C391.91 400.145 384.746 407.308 384.746 416.145C384.746 424.982 391.91 432.145 400.746 432.145Z",
    stroke: "black",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7463 80.145H112.746L160.746 352.145H416.746",
    stroke: "black",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M160.746 288.145H410.186C412.037 288.146 413.83 287.506 415.261 286.334C416.693 285.161 417.673 283.529 418.036 281.715L446.836 137.715C447.069 136.554 447.04 135.356 446.754 134.207C446.467 133.058 445.928 131.987 445.177 131.071C444.426 130.156 443.481 129.418 442.411 128.912C441.34 128.406 440.171 128.144 438.986 128.145H128.746",
    stroke: "black",
    strokeWidth: 32,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCart);
export default __webpack_public_path__ + "static/media/icon-cart.7b47d32cc6ac82528d9d68e91ce35ebc.svg";
export { ForwardRef as ReactComponent };